import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    component: () => import(/* webpackChunkName: "survey" */ '../components/NotFound')
  },
  // {
  //   path: '/profit.html',
  //   component: () => import(/* webpackChunkName: "survey" */ '../views/wh/profit')
  // },
  {
    path: '/',
    redirect: '/calc.html'
  },
  {
    path: '/calc.html',
    name: 'calc',
    component: () => import(/* webpackChunkName: "calc" */ '../views/tj/calc.vue'),
    meta: {
      title: 'Esk8 Calc'
    }
  },
  {
    path: '/belt.html',
    name: 'calc2',
    component: () => import(/* webpackChunkName: "calc" */ '../views/tj/calc2.vue'),
    meta: {
      title: 'Belt Calc'
    }
  },
  {
    path: '/three.html',
    name: 'three',
    component: () => import(/* webpackChunkName: "calc" */ '../views/tj/three.vue'),
    meta: {
      title: 'Three'
    }
  }
  // {
  //   path: '/survey.html',
  //   name: 'survey',
  //   component: () => import(/* webpackChunkName: "survey" */ '../views/survey.vue'),
  //   meta: {
  //     title: 'New Survey'
  //   }
  // }
  // {
  //   path: '/new-product-survey.html',
  //   name: 'new product',
  //   component: () => import(/* webpackChunkName: "survey" */ '../views/sr/NewProductSurvey.vue'),
  //   meta: {
  //     title: 'New Product Survey'
  //   }
  // },
  // {
  //   path: '/power-survey.html',
  //   name: 'Power',
  //   component: () => import(/* webpackChunkName: "survey" */ '../views/sr/PowerSurvey.vue'),
  //   meta: {
  //     title: 'Power Solution Survey'
  //   }
  // },
  // {
  //   path: '/design.html',
  //   name: 'Design',
  //   component: () => import(/* webpackChunkName: "survey" */ '../views/sr/Design.vue'),
  //   meta: {
  //     title: 'Apperance Design'
  //   }
  // },
  // {
  //   path: '/sr-ledsurvey',
  //   name: 'SrLedSurvey',
  //   component: () => import(/* webpackChunkName: "survey" */ '../views/sr/Ledsurvey.vue'),
  //   meta: {
  //     title: 'Light Survey,Get 20% off Coupon Code'
  //   }
  // },
  // {
  //   path: '/de-ledsurvey',
  //   name: 'DeLedSurvey',
  //   component: () => import(/* webpackChunkName: "survey" */ '../views/de/Ledsurvey.vue'),
  //   meta: {
  //     title: 'Fülllicht Umfrage'
  //   }
  // },
  // {
  //   path: '/jp-ledsurvey',
  //   name: 'JpLedSurvey',
  //   component: () => import(/* webpackChunkName: "survey" */ '../views/jp/Ledsurvey.vue'),
  //   meta: {
  //     title: 'あなたの 住んでいる国は？'
  //   }
  // },
  // {
  //   path: '/iphone12-survey.html',
  //   name: 'Iphone',
  //   component: () => import(/* webpackChunkName: "survey" */ '../views/sr/Iphone12Survey.vue'),
  //   meta: {
  //     title: 'Iphone12 Survey'
  //   }
  // },
  // {
  //   path: '/focus-survey.html',
  //   name: 'Focus',
  //   component: () => import(/* webpackChunkName: "survey" */ '../views/sr/FocusSurvey.vue'),
  //   meta: {
  //     title: 'Follow Focus Solution Survey'
  //   }
  // },
  // {
  //   path: '/satisfaction-survey.html',
  //   name: 'Satisfaction',
  //   component: () => import(/* webpackChunkName: "survey" */ '../views/kr/SatisfactionSurvey.vue'),
  //   meta: {
  //     title: 'Satisfaction Survey Questionnaire'
  //   }
  // },
  // {
  //   path: '/satisfaction.html',
  //   name: 'Sr Satisfaction',
  //   component: () => import(/* webpackChunkName: "survey" */ '../views/sr/Satisfaction.vue'),
  //   meta: {
  //     title: 'Satisfaction Survey Questionnaire'
  //   }
  // },
  // {
  //   path: '/translator.html',
  //   name: 'Translator wanted',
  //   component: () => import(/* webpackChunkName: "others" */ '../views/others/Translator.vue'),
  //   meta: {
  //     title: 'Satisfaction Survey Questionnaire'
  //   }
  // },
  // {
  //   path: '/focus-handle-survey.html',
  //   name: 'Focus handle survey',
  //   component: () => import(/* webpackChunkName: "survey" */ '../views/sr/FocusHandle.vue'),
  //   meta: {
  //     title: 'Focus handle survey'
  //   }
  // },
  // {
  //   path: '/focus-handle-de-survey.html',
  //   name: 'Focus handle survey',
  //   component: () => import(/* webpackChunkName: "survey" */ '../views/sr/FocusHandleDe.vue'),
  //   meta: {
  //     title: 'Focus handle survey'
  //   }
  // },
  // {
  //   path: '/focus-handle-kr-survey.html',
  //   name: 'Focus handle survey',
  //   component: () => import(/* webpackChunkName: "survey" */ '../views/sr/FocusHandleKr.vue'),
  //   meta: {
  //     title: 'Focus handle survey'
  //   }
  // },
  // {
  //   path: '/focus-handle-jp-survey.html',
  //   name: 'Focus handle survey',
  //   component: () => import(/* webpackChunkName: "survey" */ '../views/sr/FocusHandleJp.vue'),
  //   meta: {
  //     title: 'Focus handle survey'
  //   }
  // },
  // {
  //   path: '/member.html',
  //   name: 'To be a member of the project',
  //   component: () => import(/* webpackChunkName: "survey" */ '../views/others/Member.vue'),
  //   meta: {
  //     title: 'member'
  //   }
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  // base: '/survey/',
  routes
})

export default router
